export default __webpack_public_path__ + "static/media/locationIcon.008c004d.svg";